import React, { useState, useEffect, Fragment } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useMediaQuery } from 'hooks';
import styled, { css } from 'styled-components';
import { Line, colors } from 'globalStyle';
import { SubTitle, TextLight } from 'components/Texts';

const useStyles = makeStyles({
  infoContainer: {
    paddingTop: '20px',
    fontSize: '14px',
    textAlign: 'left',
  },
  image: {
    marginTop: '5px',
  },
  dataPair: {
    marginBottom: '10px',
  },
  seeMoreButton: {
    border: '1px solid black',
    borderRadius: '20px',
    marginBottom: '30px',
    marginTop: '15px',
    padding: '5px',
    width: '80%',
  },
});

function DataPair({
  title, children, color, className,
}) {
  return (
    <Grid container alignItems="center" className={className}>
      <Grid xs={6}>{title}</Grid>
      <Grid xs={6}>
        <SubTitle size={13} color={color}>
          {children}
        </SubTitle>
      </Grid>
    </Grid>
  );
}

function Table({
  data = [
    {
      rows: {},
      title: '',
    },
  ],

  children,
}) {
  const isDesktop = useMediaQuery(1023);
  return (
    <TableStyle isDesktop={isDesktop}>
      <thead>
        <tr>
          {Object.keys(data[0].rows).map((v) => (
            <Head>{v}</Head>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((v) => (
          <tr key={v.rows.id || v.title}>
            {v.title && (
              <Cell>
                <SubTitle number={3} align="center">
                  {v.title}
                </SubTitle>
              </Cell>

            )}
            {Object.values(v.rows).map((row) => (
              <Cell>
                <TextLight number={3} align="center" color={row.color} size={14}>
                  {row.v}
                </TextLight>
              </Cell>
            ))}
          </tr>
        ))}
      </tbody>
      {children}
    </TableStyle>
  );
}

function List({
  fullWidth,
  data = [
    {
      rows: {},
      title: '',
      icon: '',
      iconAlt: '',
    },
  ],
  titleName,
}) {
  const styles = useStyles();
  const [nRows, setNRows] = useState(0);
  const isDesktop = useMediaQuery(1023);
  useEffect(() => {
    setNRows(() => (data.length > 3 ? 3 : data.length));
  }, [data]);

  return (
    <TableStyle borderColor={colors.GRAY_3} fullWidth={fullWidth} isDesktop={isDesktop}>
      {data.slice(0, nRows).map((item, i) => (
        <Grid container key={item.id || `row-${i}-${titleName}`}>
          {(item.icon || item.title) && (
            <>
              <Grid
                container
                className={styles.infoContainer}
                justify="space-between"
              >
                <Grid item xs={10}>
                  <SubTitle size={14}>{item.title}</SubTitle>
                </Grid>
                <Grid item xs={1}>
                  <img
                    src={item.icon}
                    alt={item.iconAlt}
                    className={styles.image}
                  />
                </Grid>
              </Grid>
            </>
          )}
          <Grid container className={styles.infoContainer}>
            {Object.entries(item.rows).map(([key, value]) => (
              <DataPair
                title={key}
                key={`${item.id}-${key}`}
                color={value.color}
                className={styles.dataPair}
              >
                {value.v}
              </DataPair>
            ))}
          </Grid>
          {i !== nRows - 1 && (
            <Line
              width="100%"
              color={colors.GRAY_3}
              margin="auto"
            />
          )}
        </Grid>
      ))}
      {nRows < data.length && (
        <button
          type="button"
          onClick={() => setNRows((rows) => (rows + 3 > data.length ? data.length : rows + 3))}
          className={styles.seeMoreButton}
        >
          <SubTitle size={16} align="center">
            Cargar más
          </SubTitle>
        </button>
      )}
    </TableStyle>
  );
}

export default function TablePaymentDetails(props) {
  const bigScreen = useMediaQuery(1023);
  return bigScreen ? <Table {...props} /> : <List {...props} />;
}

const cell = css`
  padding: 10px;
  border-left: solid 1px ${colors.background.GRAY_3};
  border-right: solid 1px ${colors.background.GRAY_3};
  border-bottom: solid 1px ${colors.background.GRAY_3};
`;

export const TableStyle = styled.table`
  width: 99%;
  box-shadow: ${({ isDesktop }) => isDesktop && `0 0 0 2px ${colors.background.GRAY_3}`};  
  border-collapse: collapse;
  border-radius: 15px;
  border-style: hidden;
  text-align: center;
`;

export const Head = styled.th`
  font-size: 13px;
  padding: 10px;
  background: ${colors.background.GRAY_3};
  color: ${colors.GRAY_1};
  &:last-child {
    border-radius: 0 15px 0 0;
  }
  &:first-child {
    border-radius: 15px 0 0 0;
  }
`;

export const Cell = styled.td`
  ${cell}
  font-size: 14px;
  color: ${(props) => props.color && props.color};
`;
